import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

const KEY = "op_rn_modal_seen";
const EASE = [0.22, 1, 0.36, 1];

export const ReflectionNightModal = ({ delayMs = 10000 }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    const t = setTimeout(() => { setOpen(true); sessionStorage.setItem(KEY, "1"); }, delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const close = () => setOpen(false);

  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="rn-modal-overlay" onClick={close} role="dialog" aria-modal="true" aria-labelledby="rn-modal-title"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#2A2825]/70 backdrop-blur-sm px-5"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}>
          <motion.div data-testid="rn-modal" onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-lg bg-[#F4EFE6] text-[#2A2825] grain shadow-2xl border border-[#D1C9BE] px-7 py-12 sm:px-12 sm:py-14 text-center"
            initial={{ opacity: 0, y: 28, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 16, scale: 0.98 }} transition={{ duration: 0.6, ease: EASE }}>
            <button data-testid="rn-modal-close" onClick={close} aria-label="Close"
              className="absolute top-2 right-2 p-3 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-full text-[#5E4B3C] hover:text-[#2A2825] hover:bg-[#EAE3D9] transition-colors">
              <X className="w-5 h-5" />
            </button>
            <p className="tracking-[0.35em] uppercase text-[10px] md:text-xs text-[#A9724E] mb-5">Reflection Morning · Oct 23 · 11AM</p>
            <h2 id="rn-modal-title" className="font-serif-display font-light text-3xl sm:text-4xl leading-[1.1] mb-4">Join us for Reflection Morning <span className="italic text-[#A9724E]">on October 23.</span></h2>
            <p className="text-[#5E4B3C] font-body leading-relaxed mb-8 max-w-sm mx-auto">A morning of real stories, guided reflection, and local connection — 11AM at The Canyon House in Mission Viejo.</p>
            <div>
            <Link data-testid="rn-modal-cta" to="/reflection-nights" onClick={close}
              className="inline-flex items-center justify-center rounded-full bg-[#A9724E] hover:bg-[#8F5E3E] text-[#F4EFE6] px-8 py-3.5 text-sm tracking-wide transition-colors">
              Save My Seat
            </Link>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
